export default "__VITE_ASSET__6FvX7xuM__"